import React from 'react'
import './projects.css'
import ProjectContainer from '../components/ProjectContainer'
import Stars from '../components/Stars';

function projects() {

  return (
    <>
    <Stars/>
    <div className='container'>
      <h1 className='title'>PROJECTS</h1>
      <ProjectContainer/>
    </div>
    </>
  )
}

export default projects